import { UseFormReturn } from 'react-hook-form';

import _ from 'lodash';
import { WarehouseIcon } from 'lucide-react';

import { Badge } from 'components/Badge';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { LoadStopTypes, LoadStopsItemTypes, NormalizedLoad } from 'types/Load';
import { cn } from 'utils/shadcn';

import StopForm from '../Stop';

export function QuantumEdgeStopsTimeline({
  formMethods,
  originalSuggestionData,
}: {
  formMethods: UseFormReturn<NormalizedLoad>;
  originalSuggestionData?: NormalizedLoad;
}) {
  const stops = formMethods.watch('stops') || [];
  const sortedStops = [...stops].sort(
    (a, b) => (a.order || 0) - (b.order || 0)
  );

  return (
    <div className='w-full'>
      <Flex direction='col' gap='lg' className='w-full'>
        {sortedStops.map((stop, index) => {
          const stopLabel =
            stop.stopType === LoadStopsItemTypes.Pickup ? `Pickup` : `Dropoff`;

          return (
            <div
              key={stop.id || index}
              className='w-full px-3 py-3 bg-neutral-50 rounded border border-neutral-400 shadow-sm'
            >
              <Flex align='start' gap='sm' className='w-full'>
                <Flex direction='col' align='start' gap='sm' className='w-full'>
                  <Flex
                    align='center'
                    justify='between'
                    gap='md'
                    className='w-full'
                  >
                    <Flex align='start' className='w-full'>
                      {stop.address?.city && (
                        <Typography
                          variant='body-sm'
                          weight='semibold'
                          className='truncate max-w-[108px]'
                          title={_.startCase(_.toLower(stop.address.city))}
                        >
                          {_.startCase(_.toLower(stop.address.city))}
                        </Typography>
                      )}

                      {stop.address?.state && stop.address?.zip && (
                        <Typography
                          variant='body-sm'
                          weight='semibold'
                          className='whitespace-nowrap'
                        >
                          {`, ${stop.address.state} ${stop.address.zip}`}
                        </Typography>
                      )}
                    </Flex>

                    <Badge
                      variant='default'
                      className={cn(
                        'text-[10px]',
                        stop.stopType === LoadStopsItemTypes.Delivery
                          ? 'bg-success-50 border-success text-success'
                          : 'bg-brand-50 border-brand text-brand'
                      )}
                    >
                      {stopLabel}
                    </Badge>
                  </Flex>

                  <Flex align='end' gap='sm'>
                    <WarehouseIcon className='w-4 h-4' />
                    <Typography
                      variant='body-xs'
                      weight='bold'
                      className='text-neutral-600 leading-3.5'
                    >
                      {stop.address?.name}
                    </Typography>
                  </Flex>
                </Flex>
              </Flex>

              <div className='mt-3'>
                <StopForm
                  stop={
                    stop.stopType === LoadStopsItemTypes.Pickup
                      ? LoadStopTypes.Pickup
                      : LoadStopTypes.Consignee
                  }
                  formMethods={formMethods}
                  isCreateMode={false}
                  stopIndex={index}
                  originalSuggestionData={originalSuggestionData}
                />
              </div>
            </div>
          );
        })}
      </Flex>
    </div>
  );
}
